// AddCheckInReminder.style.ts
import {Dimensions, Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale, ravenBlack, white} from '/theme/color/on.color';
import {blueShine, codGray} from '/theme/color/secondary.color';
import {alto, wineRed} from '/theme/color/secondary.color';

const height = Dimensions.get('window').height;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: white,
  },
  scrollContainer: {
    paddingBottom: 20,
    flexGrow: 1,
  },
  content: {
    flex: 1,
    marginTop: indent * 0.8,
  },
  fieldContainer: {
    marginTop: indent * 0.8,
  },

  fieldHeading: {
    color: ravenBlack,
  },
  clickableField: {
    height: indent * 2.4,
    borderWidth: 1,
    borderColor: grayscale,
    borderRadius: 6,
    marginTop: 4,
    justifyContent: 'center',
    paddingHorizontal: indent * 0.8,
    position: 'relative',
  },
  pickerField: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  fieldText: {
    color: codGray,
  },
  datePicker: {
    marginBottom: 0,
    marginTop: 0,
    padding: 0,
  },
  viewSeparator: {
    height: 1,
    width: '100%',
    backgroundColor: alto,
  },
  buttonContainer: {
    width: '100%',
    alignItems: 'flex-end',
  },
  disableStyle: {
    opacity: 0.5,
  },
  saveButton: {
    backgroundColor: denim,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: indent * 2,
    height: indent * 2.65,
    borderRadius: 8,
  },
  saveButtonText: {
    color: white,
  },
  modal: {
    width: '100%',
    margin: 0,
    ...(Platform.OS === 'web' && {
      alignItems: 'flex-end',
    }),
  },
  modalView: {
    height: Platform.OS === 'web' ? '100%' : height > 684 ? '55%' : '80%',
    marginTop: Platform.OS === 'web' ? 0 : 'auto',
    backgroundColor: white,
    borderTopLeftRadius: Platform.OS === 'web' ? 0 : 10,
    borderTopRightRadius: Platform.OS === 'web' ? 0 : 10,
    width: Platform.OS === 'web' ? 450 : '100%',
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  headerText: {
    marginLeft: 10,
  },
  radioButtonsContainer: {
    flexDirection: 'column',
    marginHorizontal: 20,
  },
  buttonDeleteContainer: {
    borderWidth: 1,
    borderColor: alto,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: indent * 0.8,
    height: indent * 2.65,
  },
  button: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
  },
  buttonText: {
    color: codGray,
  },
  plusIcon: {
    marginRight: indent * 0.4,
    fontSize: 16,
    color: wineRed,
  },
  messageBanner: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  infoIcon: {
    color: blueShine,
  },
  closeText: {
    color: codGray,
    paddingLeft: 16,
    flex: 1,
    fontWeight: 'bold',
  },
  loadingIndicator: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  webDatePickerContainer: {
    marginTop: indent * 0.4,
    padding: indent * 0.4,
  },
  webDatePicker: {
    padding: indent * 0.6,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: grayscale,
    fontSize: 16,
    width: '100%',
    color: codGray,
    backgroundColor: white,
    fontFamily: 'inherit',
  },
  webHiddenInput: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.01,
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    zIndex: 1,
  },

  errorMessageText: {
    marginTop: 20,
    color: codGray,
    lineHeight: 24,
  },
  errorCloseButton: {
    marginTop: 30,
    backgroundColor: denim,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  errorCloseButtonText: {
    color: white,
    fontWeight: 'bold',
  },
});

export default styles;
